import jwt from 'jsonwebtoken'
//import Vue from 'vue';

export const verify = function (token,secret) {
    console.log('--------------- verify request------------');
    //console.log(token);
    let accessToken = token;

    //let payload
    try {
        //use the jwt.verify method to verify the access token
        //throws an error if the token has expired or has a invalid signature
        // eslint-disable-next-line no-unused-vars
        return jwt.verify(accessToken, secret,(err, decoded)=>{
            console.log(err)
            if(err){

                sessionStorage.clear();
                // Vue.$cookies.delete("isAuth");
                // Vue.$cookies.delete("token");
                //window.location.href='/';
                //console.log(window.location.pathname)
                if(window.location.pathname != '/'){
                    window.location.href='/';
                }
                return false;
            }
            console.log(decoded)
            return true
        })

    }
    catch (e) {
        //if an error occured return request unauthorized error
        return e;
    }
}

export const generateJwtToken = function ( data) {
    //console.log(data)
    //console.log(process.env)
    //const { email, password } = data;
    // if( !username || !password ) {
    //     return
    // }
    const secretKey = process.env.VUE_APP_ACCESS_TOKEN_SECRET;
    try {
        let payload = {
            iss: process.env.VUE_APP_TOKEN_ISS,
            aud: process.env.VUE_APP_TOKEN_AUD,
            //nbf: Math.floor(Date.now() / 1000),
            exp: Math.floor(Date.now() / 1000) + ( parseInt(process.env.VUE_APP_ACCESS_TOKEN_LIFE) *60 ) ,
            payload: data
        }
        //console.log(payload)
         return jwt.sign(payload, secretKey, {
             algorithm: "HS256",
             //expiresIn: process.env.VUE_APP_ACCESS_TOKEN_LIFE
         });

        // return await  encrypt(payload)
        //     .setProtectedHeader({ alg: 'dir', enc: 'HS256' })
        //     .setIssuedAt()
        //     .setIssuer('Line')
        //     .setAudience('Carabao')
        //     .setExpirationTime('2h')
        //     .encrypt( process.env.VUE_APP_ACCESS_TOKEN_SECRET )
        //return  jwt.sign( payload, secretKey )
    } catch (e) {
        return e;
    }


}

// export const verifyToken = function (secretKey, token) {
//     //console.log(data)
//     //console.log(process.env)
//     //const { email, password } = data;
//     // if( !username || !password ) {
//     //     return
//     // }
//     try {
//         return  jwt.sign( token, secretKey )
//     } catch (e) {
//         return e
//     }


// }
